import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useAxios from "../../../../MainComponents/Hooks/useAxios.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import HelmetTags from "../../../../MainComponents/HelmetTags.jsx";

const CodesTracker = ({ activation }) => {
  const [submitState, setSubmitState] = useState({
    flag: "",
    dependency: false,
    data: {},
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
    watch,
  } = useForm({
    mode: "onTouched",
    defaultValues: { code_type: "1" },
  });

  const codeType = watch("code_type");

  const api = activation
    ? process.env.REACT_APP_ADMIN_ACTIVATION_CODE_TRACKER_API
    : process.env.REACT_APP_ADMIN_CODE_TRACKER_API;

  const [trackSuccess, trackErrors, submitLoading] = useAxios(
    api,
    "POST",
    submitState.flag,
    submitState.dependency,
    submitState.data,
    true
  );

  useEffect(() => {
    if (trackSuccess) reset();
  }, [trackSuccess]);

  const onSubmit = (data) => {
    const value = data.query.trim();
    let payload;

    if (activation) {
      payload = { serial: value };
    } else {
      const isNumeric = /^\d+$/.test(value);
      payload = {
        is_code: data.code_type,
        ...(isNumeric ? { code_id: Number(value) } : { code: value }),
      };
    }

    setSubmitState({
      flag: "tracker",
      dependency: !submitState.dependency,
      data: payload,
    });
  };

  return (
    <section className="dark:bg-dark dark:text-light h-full w-full overflow-y-auto px-10 py-10 sm:px-4">
      <HelmetTags
        title={`${activation ? "Activation " : ""}Codes Tracker | Mr.Mohamed Salama`}
      />

      <h2 className="mb-7 text-start sm:text-center text-2xl font-bold">
        {activation ? "Activation " : ""}Codes Tracker
      </h2>

      <div className="flex w-full items-start justify-center my-20">
        <div className="admin-content-form flex h-fit w-full max-w-lg flex-col items-stretch gap-6 rounded-3xl bg-white p-10 shadow-md">
          {trackErrors && (
            <p className="text-center font-bold text-red-600">
              {trackErrors?.response?.data?.message}
            </p>
          )}
          {trackSuccess?.message && (
            <p className="text-center font-bold text-green-600 dark:text-green-400">
              {trackSuccess?.message}
            </p>
          )}

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-6"
          >
            {!activation && (
              <div className="flex flex-col gap-2">
                <label className="font-semibold" htmlFor="code_type">
                  Code Type
                </label>
                <select
                  id="code_type"
                  {...register("code_type", { required: true })}
                >
                  <option value="1">Codes</option>
                  <option value="0">Points Codes</option>
                  <option value="2">Offer Codes</option>
                </select>
              </div>
            )}

            <div className="flex flex-col gap-2">
              <label className="font-semibold" htmlFor="query">
                {activation ? "Serial Number" : "Code ID or Code"}
              </label>
              <input
                className="signin-inputs w-full pl-4"
                type="text"
                id="query"
                placeholder={
                  activation
                    ? "Enter serial number"
                    : "Enter code ID or code text"
                }
                {...register("query", {
                  required: true,
                  minLength: 1,
                })}
              />
              {errors.query && (
                <p className="text-xs text-red-500">This field is required.</p>
              )}
              {trackErrors?.response?.data?.errors?.code_id && (
                <p className="text-xs text-red-500">
                  {trackErrors.response.data.errors.code_id[0]}
                </p>
              )}
              {trackErrors?.response?.data?.errors?.code && (
                <p className="text-xs text-red-500">
                  {trackErrors.response.data.errors.code[0]}
                </p>
              )}
              {trackErrors?.response?.data?.errors?.serial && (
                <p className="text-xs text-red-500">
                  {trackErrors.response.data.errors.serial[0]}
                </p>
              )}
            </div>

            <button
              disabled={!isValid || (submitLoading && submitState.flag)}
              className="submit mt-2 w-full"
              type="submit"
            >
              {submitLoading && submitState.flag ? (
                <FontAwesomeIcon icon={faSpinner} spin />
              ) : (
                "Track"
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CodesTracker;
